module.exports = __webpack_public_path__ + "img/m_btn.de6c73a1.png";